<div class="row d-flex justify-content-end">
  <a class="btn btn-sm btn-dark mr-5" [routerLink]="['/admin_panel/bucket_details']" routerLinkActive="router-link-active" >Back</a>
</div>

<div style="margin-right: 32px;">
  <div>
      <h4 class="title" style="margin-top: 15px;">Allocation</h4>
  </div>
</div>

<div class="card" style="padding: 10px; border-radius:10px;">
  <div class="d-flex justify-content-around" style="font-size: 20px;">
      <div>
          <p><b>BANK NAME: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.bank_name.bank_name}}</span></p>
      </div>
      <div>
          <p><b>PORTFOLIO: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.portfolio_id.portfolio_type}}</span></p>
      </div>
      <div>
          <!-- <p><b>PRODUCT: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.product_id.product_type}} </span></p> -->
      </div>
      <div>
        <p><b>Allocation ID: </b> <span style="font-size: 16px; color:#2196f3;"> {{bucket_detail.bucket_id}} </span></p>
    </div>
  </div>
</div>

<br>
<div class="row">
  <div class="col-md-6">
    <h5 class="form-lable">Choose Designations</h5>
    <p-dropdown [options]="Designation_details1" (onChange)="fetchuser_1()" [(ngModel)]="report_to_design"
      placeholder="Report to Designations" optionLabel="y" [showClear]="true"></p-dropdown>
    </div>
    
    
    <div class="col-md-6">
    <h5 class="form-lable">Choose User Details</h5>
    <p-dropdown [options]="User_details1" (onChange)="Report_fetch()" [(ngModel)]="report_to"
      placeholder="Report to User Details" optionLabel="y" [showClear]="true"></p-dropdown>
    </div>
</div>

<div style="margin: 2px;padding-bottom: 15px;" >

  <div class="row">

      <div class="col-md-12">
          <div>
          <h4 class="title-f" style="color: #0a2440;font-weight: 600;border-bottom: 2px solid;">Accounts Details</h4>


          <h4 class="title-f">New Accounts</h4>
          <div class="d-flex justify-content-end mt-3 mb-1">
            <button class="btn btn-primary" style="margin-top: -25px;" (click)="submit_allocation()">Click here to Save Allocate</button>
          </div>
         <div class="animate" *ngIf="!loading">

         </div>
         <div class="d-flex justify-content-around" *ngIf="loading">
          <p><b style="font-size: 16px;">New Accounts: </b>{{new_count}}</p> <p><b style="font-size: 16px;">Exsisting Accounts:</b>{{exisiting_count}}</p>
         </div>
          <!-- <div *ngIf="loading" >
              <ag-grid-angular #agGrid
                  style="width: auto; height: 600px;"
                  class="ag-theme-alpine"
                  [rowData]="saved_Fields"
                  [rowSelection]="'multiple'"
                  [columnDefs]="AllocationcolumnDefs"
                  [pagination]="true">
              </ag-grid-angular>



          </div> -->

          <p> Not Allocated Account Details </p>
          <div *ngIf="loading" >
              <ag-grid-angular #agGrid
                  style="width: auto; height: 600px;"
                  class="ag-theme-alpine"
                  [rowData]="saved_Fields_New"
                  [rowSelection]="'multiple'"
                  [columnDefs]="AllocationcolumnDefs"
                  [pagination]="true">
              </ag-grid-angular>
          </div>

          <p> Allocated Account Details </p>

          <div class="d-flex justify-content-end mt-3 mb-1">
            <button class="btn btn-primary" style="margin-top: -25px;" (click)="submit_allocation2()">Click here to Allocate old user</button>
            <button class="btn btn-primary" style="margin-top: -25px;" (click)="showPositionDialog()">Click here to Re-Allocate</button>
          </div>

          <div *ngIf="loading" >
            <ag-grid-angular #agGrid2
                style="width: auto; height: 600px;"
                class="ag-theme-alpine"
                [rowData]="saved_Fields_Existing"
                [rowSelection]="'multiple'"
                [columnDefs]="AllocationcolumnDefs"
                [pagination]="true">
            </ag-grid-angular>
        </div>


        
          </div>
      </div>
  </div>
</div>

<p-dialog header="Allocate to" [(visible)]="displayPosition" position="center" [modal]="true"
[style]="{width: '500px',height : '600px'} " [baseZIndex]="10000" [draggable]="false" [resizable]="false">
<div class="row" style="margin-left: 0px;margin-right: 0px;">
    <div class="col-md-12">
        <div class="row" style="padding: 0px 0px 6px 10px;">
            <div class="col-md-12 detail-t">
              <div class="row">
                  <div class="col-md-12">
                    <h5 class="form-lable">Choose Designations</h5>
                    <p-dropdown [options]="Designation_details_one" (onChange)="fetchuser_2()" [(ngModel)]="report_to_design_one"
                      placeholder="Report to Designations" optionLabel="y" [showClear]="true"></p-dropdown>
                    </div>
                    <br>
                    <div class="col-md-12">
                    <h5 class="form-lable">Choose User Details</h5>
                    <p-dropdown [options]="User_details2" (onChange)="Report_fetch_1()" [(ngModel)]="report_to_one"
                      placeholder="Report to User Details" optionLabel="y" [showClear]="true"></p-dropdown>
                    </div>
                    <br>
                    <div class="col-md-12">
                      <h5 class="form-lable">Action</h5>
                        <button class="btn btn-primary" (click)="showPositionDialog_hide()">Allocate</button>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>
</p-dialog>
